import * as React from 'react';
import {Checkbox, Col, Row} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import {CheckboxChangeEvent} from "antd/lib/checkbox";

export interface CheckBoxFormItemProps extends BaseFormItemProps {
  onChange?: (e: CheckboxChangeEvent) => void;
}

class CheckBoxFormItem extends React.Component<CheckBoxFormItemProps, {}> {

  public render(): React.ReactNode {
    const {disabled, label, onChange} = this.props;
    return (
      <Row>
        <Col xs={24} sm={8}/>
        <Col xs={24} sm={16}>
          <BaseFormItem
            {...this.props}
            label={undefined}
            valuePropName="checked"
            input={
              <Checkbox disabled={disabled} onChange={onChange}>{label}</Checkbox>
            }
          />
        </Col>
      </Row>

    );
  }
}

export default CheckBoxFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/CheckBoxFormItem.tsx